import { Button, Col,  Input, message, Row, Skeleton,  Typography } from 'antd'
import { FormComponent } from 'components/BaseComponent'
import { ShelterContextData } from 'context/ShelterContext'
import { ShelterSettingContextData } from 'context/ShelterSettingContext'
import React from 'react'
import { ShelterSettingDiscountReasonSaveRequest } from 'services/api/interfaces/ApiRequest'


type PetProfileProps = {
  uuid: string
  context: ShelterContextData
  settingsContext: ShelterSettingContextData
}

export default class DiscountReason extends FormComponent<PetProfileProps> {

  state = {
    loaded: false,
    reasons: []
  }

  async componentDidMount() {
    const { uuid, settingsContext } = this.props

    if (uuid && !settingsContext.fetching) {
      await settingsContext.requestShelterSettingList({
        search: {
          organization_shelter: {
            has: {
              uuid
            }
          }
        }
      })
    }
    this.setState({
      loaded: true,
      reasons: this.getValues()?.discount_reason || [],
    })
  }

  private getValues = () => {
    const { settingsContext } = this.props

    const values = settingsContext.shelterSettings?.find(v => v.type_key === 'DISCOUNT_REASON')?.value as any
    return values
  }

  private handleSave = async (values: any) => {
    const { uuid, settingsContext } = this.props
    try {
      const payload: ShelterSettingDiscountReasonSaveRequest = {
        shelter_uuid: uuid,
        type_key: 'DISCOUNT_REASON',
        value: {
          discount_reason: this.state.reasons,
        }
      }

      await settingsContext.requestShelterSettingDiscountReasonSave(payload)
      message.success('Pet profile saved successfully!')
    } catch (error) {
      message.error(`Failed to save pet profile. Reason: ${error}`)
    }
  }

  private handleChange = async (values: any[], allValues?: any[]) => {
    /*const { allow_adoption } = this.state.fieldValues
    console.log("teste",values)
    for await (const v of values) {
      const fieldName = v.name[0]
      allow_adoption[fieldName] = v?.value
    }
    console.log(allow_adoption)
    this.setState({
      fieldValues : {
        allow_adoption
      }
    })*/
  }

  addReason() {
    let reasons = this.state.reasons ;
    (reasons as any).push("");
    this.setState({
      reasons
    })
  }

  remove(index: number){
    let reasons = this.state.reasons ;
    //reasons = reasons.splice(index, 1);
    //delete reasons[index]
    this.setState({
      reasons: reasons.filter((item) => item !== reasons[index])
    })
  }

  changeValue(index: number,value : string){
    let reasons = this.state.reasons;
    //reasons = reasons.splice(index, 1);
    (reasons as any)[index] = value;
    this.setState({
      reasons
    })
  }

  
  render() {
    const { settingsContext } = this.props
    const { loaded } = this.state

    if (!loaded) {
      return <Skeleton />
    }

    return (
      <div>
          <Row gutter={24}>
            <Col xs={24} sm={12} md={12}>
              <div>
                <Typography.Title level={5}>Discount reason</Typography.Title>
                <Typography.Text>Upon adoption approval in Adopets, shelters can add a discount reason when discounting the original value of the pet’s adoption fee. The available shelter discount reasons are configured below.</Typography.Text>
                <br/><br/>
                {
                  this.state.reasons?.map((item,index) => {
                    return <div style={{marginBottom: 8,display: "flex", flexDirection:"column",alignItems:"flex-end"}}>
                    <Input onChange={(value) => this.changeValue(index,value.target.value)} value={item}/>
                    <button onClick={() => {
                      this.remove(index);
                    }} style={{color:"#e52e6b",background:"transparent",border:0,cursor:"pointer"}}>Remove</button>
                  </div>
                  })
                }
                <button onClick={() => this.addReason()} style={{color:"#e52e6b",background:"transparent",border:0,cursor:"pointer",width:"100%",marginBottom:16}}>ADD REASON</button>
              </div>
            </Col>
          </Row>

          <Button
            type="primary"
            htmlType="submit"
            size="large"
            loading={!!settingsContext.fetching}
            onClick={()=> {
              this.handleSave("")
            }}
            block
          >
            Save
          </Button>
      </div>
    )
  }
}
